export const createOrUpdateCookie = (key, value, exp, maxAge) => {
    let cookieString = `${key}=${value}`;
    if (exp) {
        cookieString = `${cookieString}; expires=${exp}`;
    }
    if (maxAge) {
        cookieString = `${cookieString}; max-age=${maxAge}`;
    }
    document.cookie = cookieString;
};

export const getAllCookies = () => {
    const cookieString = document.cookie;
    const cookieArr = cookieString.split(';');
    const cookieObj = {};
    for (let i = 0; i < cookieArr.length; i += 1) {
        const splitStr = cookieArr[i].split('=');
        const [key, value] = splitStr;
        cookieObj[key.trim()] = value;
    }
    return cookieObj;
};

export const getCookie = (key) => {
    const regex = new RegExp(`(?:(?:^|.*;\\s*)${key}\\s*\\=\\s*([^;]*).*$)|^.*$`);
    return document.cookie.replace(regex, '$1');
};

export const removeCookie = (key) => {
    document.cookie = `${key}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
